import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default async function toggleClientMute(userdata: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (userdata.isMuted || !OperatorAccountStore.showFreeDialogForSite(userdata.siteId)) {
        let newValue = !userdata.isMuted;
        userdata.isMuted = newValue;
        let p: OperatorApplicationApi.OperatorBuddyListSetMutedOpenApiModel = {
            username: userdata.username,
            muted: newValue
        };
        let result = await (new OperatorApiRequest({
            url: "/buddyList/setMuted",
            p,
            silent: true
        })).send();
        if (result.showMessageOnError()) {
            userdata.isMuted = !newValue;
        }
    }
}